import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';

export default function PaymentPending() {
  const navigate = useNavigate();
  const { checkAuth, user } = useAuth();

  useEffect(() => {
    const verifyStatus = async () => {
      try {
        await checkAuth();
      } catch {}
    };
    verifyStatus();
  }, [checkAuth]);

  useEffect(() => {
    if (user && user.is_pro === 1) {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="mb-4">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100">
              <svg className="h-6 w-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M12 2a10 10 0 100 20 10 10 0 000-20z" />
              </svg>
            </div>
          </div>

          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Pagamento em Processamento
          </h2>

          <p className="text-gray-600 mb-6">
            Estamos confirmando seu pagamento com o Mercado Pago. Assim que for aprovado, seu acesso PRO será ativado automaticamente.
          </p>

          <button
            onClick={() => navigate('/dashboard')}
            className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
          >
            Ir para Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}

